<!--
 * @Author: ken yang
 * @Date: 2025-04-17 17:31:49
 * @LastEditTime: 2025-04-17 19:25:49
 * @LastEditors: ken yang
 * @Description:
 * @FilePath: /uexch_pc/src/layout/appHeader/rightMenu/DownloadMenu.vue
-->
<template>
  <el-dropdown
    id="downloadApp"
    :popper-class="`dropdown-no-arrow el-popper-box-p-0 DownloadMenu-popper ${!isHasSetIcon() ? '-m-l-20' : ''}`"
    :teleported="true"
    :hide-timeout="200"
  >
    <Row class="w-32px h-32px rd-full header-round-hover-bg cursor-pointer" x="c" y="c">
      <IconSvg class="text-white title transition pointer  font-18" name="icon-download" test-key="down-app" />
    </Row>
    <template #dropdown>
      <Column class="box-border w-178px h-200px p-12px rd-8px!" y="c" x="c">
        <Row class=" downloadQrCode-box" x="c" y="c">
          <QrCode id="downloadApp-QrCode" :url="`${h5Url}/downloadApp?locale=${configStore.locale}`" :size="146" />
        </Row>
        <span class="font-12 mt-4px">{{ $t('public.scanCodeDownloadApp') }}</span>
      </Column>
    </template>
  </el-dropdown>
</template>
<script setup>
import { getBusinessPath } from '@/utils/localeRoute.js'

const configStore = useConfigStore()
const route = useRoute()
const businessPath = $computed(() => getBusinessPath(route.path))
const isHasSetIcon = () => {
  return ['/trade', '/futures'].includes(businessPath)
}
</script>
<style lang="scss">
.DownloadMenu-popper.el-popper {
  --el-popper-border-radius: 8px !important;
  border-radius: 8px !important;
  overflow: hidden;
}
</style>
